import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getDemoState } from './helpers';

import { LenderStatus } from '../constants';

interface DemoStatusContentHook {
  state: LenderStatus;
}

export default function useDemoStatusContent(): DemoStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getDemoState(job, credit, deposit);
  }, [isLoading, job, credit, deposit]);

  return {
    state,
  };
}
